import {MAINTANCE_ERROR} from "@/src/shared/const";

const isMaintanceError = (message: string | undefined): boolean => {
    if (!message) return false;
    return message === MAINTANCE_ERROR
}

export { isMaintanceError }
